import React, { useState } from "react";
import { IAttendanceQuery } from "../../models/Hrm";
import { useGetMyAttendance } from "../../query/HrmQuery";
import HrmAttendanceTable from "../../components/hrm/HrmAttendanceTable";
import { Button, Flex } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const PersonalAttendance = () => {
  const [filter, setFilter] = useState<IAttendanceQuery>({
    page: 1,
    limit: 10,
  });
  const navigate = useNavigate();
  const { data, isLoading } = useGetMyAttendance(filter);
  return (
    <div className="flex flex-col h-full p-4 rounded-xl">
      <Flex align="center" gap="small" className="mb-6">
        <Button
          type="default"
          size="large"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          className=" bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
        >
          Quay lại
        </Button>
      </Flex>
      <HrmAttendanceTable
        data={data}
        filter={filter}
        setFilters={setFilter}
        isLoading={isLoading}
      />
    </div>
  );
};

export default PersonalAttendance;
